;(function () {
  'use strict'
  angular.module('contrast.security').constant('passwordStrength', {
    WEAK: {
      name: 'Weak',
      description: 'none',
      translationId: 'detail_weakPassword',
      req: {
        // Snake case in order to match the API response names
        min_password_upper: 0,
        min_password_lower: 0,
        min_password_numbers: 0,
        min_password_symbols: 0
      }
    },
    MEDIUM: {
      name: 'Medium',
      description: 'digit required',
      translationId: 'detail_mediumPassword',
      req: {
        min_password_upper: 0,
        min_password_lower: 0,
        min_password_numbers: 1,
        min_password_symbols: 0
      }
    },
    STRONG: {
      name: 'Strong',
      description: 'mixed case, digit & special character required',
      translationId: 'detail_strongPassword',
      req: {
        min_password_upper: 1,
        min_password_lower: 1,
        min_password_numbers: 1,
        min_password_symbols: 1
      }
    },
    COMPLEX: {
      name: 'Complex',
      description: 'mixed case, 2 digits & 2 special characters required',
      translationId: 'detail_complexPassword',
      req: {
        min_password_upper: 1,
        min_password_lower: 1,
        min_password_numbers: 2,
        min_password_symbols: 2
      }
    },
    CUSTOM: {
      name: 'Custom',
      description: null,
      translationId: 'detail_customPassword',
      req: {
        min_password_upper: null,
        min_password_lower: null,
        min_password_numbers: null,
        min_password_symbols: null
      }
    }
  })
})()
